export default "__VITE_ASSET__f5d804c1__"